import { render } from "./IosPermissionsIntegrationSettings.vue?vue&type=template&id=05d702b8"
import script from "./IosPermissionsIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./IosPermissionsIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__